import { Menu } from "@/types";

export const SIDE_MENUS: Menu[] = [
  {
    id: 1,
    title: "お知らせ管理",
    active: false,
    path: "/information",
    items: [
      {
        id: 1,
        title: "公開前／公開中",
        url: "/information/current",
        is_edit_page: false,
      },
      {
        id: 2,
        title: "公開終了",
        url: "/information/end",
        is_edit_page: false,
      },
      {
        id: 3,
        title: "新規作成",
        url: "/information/form/0",
        is_edit_page: true,
      },
    ],
  },
  {
    id: 2,
    title: "サポート管理",
    active: false,
    path: "/inquiry",
    items: [
      {
        id: 2,
        title: "問い合わせ進行中",
        url: "/inquiry/inprogress",
        is_edit_page: false,
      },
      {
        id: 3,
        title: "問い合わせ完了",
        url: "/inquiry/completed",
        is_edit_page: false,
      },
      {
        id: 1,
        title: "新規作成",
        url: "/inquiry/0/edit",
        is_edit_page: true,
      },
      {
        id: 4,
        title: "iBowヘルプ(テンプレート)",
        url: "/template",
        is_edit_page: false,
      },
      {
        id: 5,
        title: "おすすめキーワード",
        url: "/template/recommendkeyword",
        is_edit_page: true,
      },
      {
        id: 6,
        title: "iBowヘルプ並び替え",
        url: "/template/sort",
        is_edit_page: false,
      },
    ],
  },
  {
    id: 11,
    title: "問い合わせマスタ管理",
    active: false,
    path: "/inquiry-master",
    items: [
      {
        id: 1,
        title: "サービス種類",
        url: "/inquiry-service-div/list",
        is_edit_page: false,
      },
      {
        id: 2,
        title: "問い合わせグループ",
        url: "/inquiry-group/list",
        is_edit_page: false,
      },
      {
        id: 3,
        title: "問い合わせサブグループ",
        url: "/inquiry-sub-group/list",
        is_edit_page: false,
      },
      {
        id: 4,
        title: "問い合わせ種類",
        url: "/inquiry-div/list",
        is_edit_page: false,
      },
    ],
  },
  {
    id: 3,
    title: "契約管理",
    active: false,
    path: "/contract",
    items: [
      {
        id: 1,
        title: "契約管理企業",
        url: "/contractmanagement/list",
        is_edit_page: false,
      },
      {
        id: 2,
        title: "未確定契約一覧",
        url: "/contractreception/list",
        is_edit_page: false,
      },
    ],
  },
  {
    id: 4,
    title: "メンテ設定",
    active: false,
    path: "/maintenance",
    items: [
      {
        id: 1,
        title: "公開前/公開中",
        url: "/maintenance/notification",
        is_edit_page: false,
      },
      {
        id: 2,
        title: "公開終了",
        url: "/maintenance/finish",
        is_edit_page: false,
      },
      {
        id: 3,
        title: "新規作成",
        url: "/maintenance/edit/0",
        is_edit_page: true,
      },
    ],
  },
  {
    id: 5,
    title: "アンケート管理",
    active: false,
    path: "/research",
    items: [
      {
        id: 1,
        title: "公開前/公開中",
        url: "/research/current",
        is_edit_page: false,
      },
      {
        id: 2,
        title: "公開終了",
        url: "/research/end",
        is_edit_page: false,
      },
      {
        id: 3,
        title: "新規作成",
        url: "/research/edit/0",
        is_edit_page: true,
      },
    ],
  },
  {
    id: 6,
    title: "基本設定",
    active: false,
    path: "/configuration",
    items: [
      {
        id: 1,
        title: "基本設定",
        url: "/configuration/show",
        is_edit_page: false,
      },
      {
        id: 2,
        title: "エクスポート",
        url: "/configuration/export",
        is_edit_page: false,
      },
      {
        id: 3,
        title: "集計情報",
        url: "/configuration/viewer",
        is_edit_page: false,
      },
    ],
  },
  {
    id: 7,
    title: "iBowログイン",
    active: false,
    path: "/ibowlogin",
    items: [
      {
        id: 1,
        title: "iBowにログイン",
        url: "/ibowlogin/login",
        is_edit_page: false,
      },
      {
        id: 2,
        title: "iBowユーザとしてログイン",
        url: "/ibowlogin/spoofing",
        is_edit_page: false,
      },
    ],
  },
  {
    id: 8,
    title: "ユーザー管理",
    active: false,
    path: "/user",
    items: [
      {
        id: 1,
        title: "一覧",
        url: "/user/list",
        is_edit_page: false,
      },
      {
        id: 2,
        title: "権限一覧",
        url: "/auth/list",
        is_edit_page: false,
      },
    ],
  },
  {
    id: 9,
    title: "オペレーションログ",
    active: false,
    path: "/operationlog",
    items: [
      {
        id: 1,
        title: "iBow2オペレーションログ",
        url: "/operationlog/show",
        is_edit_page: false,
      },
      {
        id: 2,
        title: "管理者オペレーションログ",
        url: "/admin/operationlog/show",
        is_edit_page: false,
      },
      {
        id: 2,
        title: "けあログっとオペレーションログ",
        url: "/portal/operationlog/show",
        is_edit_page: false,
      },
    ],
  },
  {
    id: 15,
    title: "デモサイト管理",
    active: false,
    path: "/demosite",
    items: [
      {
        id: 1,
        title: "一括作成",
        url: "/demosite/input",
        is_edit_page: false,
      },
    ],
  },
  {
    id: 16,
    title: "職員一括連携解除",
    active: false,
    path: "/stafflink",
    items: [
      {
        id: 1,
        title: "職員一括連携解除",
        url: "/stafflink/release",
        is_edit_page: false,
      },
    ],
  },
  {
    id: 10,
    title: "iBowアカウント管理",
    active: false,
    path: "/ibowaccount",
    items: [
      {
        id: 1,
        title: "一覧",
        url: "/ibowaccount/list",
        is_edit_page: false,
      },
      {
        id: 2,
        title: "復元/消去",
        url: "/ibowaccount/deleted_list",
        is_edit_page: false,
      },
      {
        id: 3,
        title: "停止解除",
        url: "/ibowaccount/stopped_list",
        is_edit_page: false,
      },
    ],
  },
  {
    id: 17,
    title: "AIお勧め検索管理",
    active: false,
    path: "/recommend",
    items: [
      {
        id: 1,
        title: "一覧",
        url: "/recommend/list",
        is_edit_page: false,
      },
    ],
  },
  {
    id: 18,
    title: "サービスリンク",
    active: false,
    path: "/service_link",
    items: [
      {
        id: 1,
        title: "一覧",
        url: "/service_link/list",
        is_edit_page: false,
      },
      {
        id: 2,
        title: "並び替え",
        url: "/service_link/sort",
        is_edit_page: false,
      },
      {
        id: 3,
        title: "カテゴリ",
        url: "/service_link/category",
        is_edit_page: false,
      },
      {
        id: 4,
        title: "お問合せログ",
        url: "/service_link/mail_log",
        is_edit_page: false,
      },
    ],
  },
  {
    id: 19,
    title: "看護計画書AI自動作成管理",
    active: false,
    path: "/ai-vnplan",
    items: [
      {
        id: 1,
        title: "インデックス設定",
        url: "/ai-vnplan/index/config",
        is_edit_page: false,
      },
      {
        id: 2,
        title: "表示設定",
        url: "/ai-vnplan/viewset",
        is_edit_page: false,
      },
    ],
  },
  {
    id: 20,
    title: "月次報告書AI自動作成管理",
    active: false,
    path: "/ai-monthreport",
    items: [
      {
        id: 1,
        title: "表示設定",
        url: "/ai-monthreport/viewset",
        is_edit_page: false,
      },
    ],
  },
  {
    id: 28,
    title: "けあログっとログイン",
    active: true,
    path: "/portallogin",
    items: [
      {
        id: 1,
        title: "けあログっと掲載側職員でログイン",
        url: "/portallogin/portalstaff-agent-login",
        is_edit_page: false,
      },
      {
        id: 2,
        title: "けあログっと紹介側職員でログイン",
        url: "/portallogin/requestuser-agent-login",
        is_edit_page: false,
      },
    ],
  },
  {
    id: 29,
    title: "けあログっと管理",
    active: true,
    path: "/portal",
    items: [
      {
        id: 1,
        title: "掲載側 一覧",
        url: "/portal/portal-office/list",
        is_edit_page: false,
      },
      {
        id: 3,
        title: "紹介側 一覧",
        url: "/portal/organization/list",
        is_edit_page: false,
      },
      {
        id: 5,
        title: "メール送信ログ",
        url: "/portal/mail-log/list",
        is_edit_page: false,
      },
    ],
  },
  {
    id: 30,
    title: "けあログっと運営からのお知らせ",
    active: true,
    path: "/portal-announcement",
    items: [
      {
        id: 1,
        title: "けあログっと運営からのお知らせ",
        url: "/portal-announcement/list",
        is_edit_page: true,
      },
    ],
  },
  {
    id: 28,
    title: "カエドキログイン",
    active: true,
    path: "/jobsearch-login",
    items: [
      {
        id: 1,
        title: "カエドキ掲載側職員でログイン",
        url: "/jobsearch-login/recruiter-agent-login",
        is_edit_page: false,
      },
      {
        id: 2,
        title: "カエドキ応募者でログイン",
        url: "/jobsearch-login/recruitee-agent-login",
        is_edit_page: false,
      },
    ],
  },
  {
    id: 33,
    title: "カエドキ管理",
    active: true,
    path: "/jobsearch",
    items: [
      {
        id: 1,
        title: "求人側 一覧",
        url: "/jobsearch/portal-office/list",
        is_edit_page: false,
      },
      {
        id: 2,
        title: "求人 一覧",
        url: "/jobsearch/jobsearch-listing/list",
        is_edit_page: false,
      },
      {
        id: 3,
        title: "応募カード 一覧",
        url: "/jobsearch/jobsearch-application/list",
        is_edit_page: false,
      },
      {
        id: 4,
        title: "応募側 一覧",
        url: "/jobsearch/jobsearch-recruitee/list",
        is_edit_page: false,
      },
      {
        id: 5,
        title: "口コミ一覧",
        url: "/jobsearch/portal-office-review/list",
        is_edit_page: false,
      },
      {
        id: 6,
        title: "お役立ち情報設定",
        url: "/jobsearch/useful-wp-config",
        is_edit_page: false,
      },
      {
        id: 7,
        title: "紹介情報管理",
        url: "/jobsearch/referral-registrations",
        is_edit_page: false,
      },
    ],
  },
  {
    id: 34,
    title: "カエドキ運営からのお知らせ",
    active: true,
    path: "/jobsearch-announcement",
    items: [
      {
        id: 2,
        title: "カエドキ運営からのお知らせ",
        url: "/jobsearch-announcement/list",
        is_edit_page: true,
      },
    ],
  },
  {
    id: 31,
    title: "請求お知らせ管理",
    active: false,
    path: "/invoicenotice",
    items: [
      {
        id: 1,
        title: "公開前／公開中",
        url: "/invoicenotice/current",
        is_edit_page: false,
      },
      {
        id: 2,
        title: "公開終了",
        url: "/invoicenotice/end",
        is_edit_page: false,
      },
      {
        id: 3,
        title: "新規作成",
        url: "/invoicenotice/edit/0",
        is_edit_page: true,
      },
    ],
  },
  {
    id: 32,
    title: "AIルートトピックス管理",
    active: false,
    path: "/airoute-topics",
    items: [
      {
        id: 1,
        title: "AIルートトピックス管理",
        url: "/airoute-topics/edit",
        is_edit_page: false,
      },
    ],
  },
  {
    id: 36,
    title: "AI経営分析レポート管理",
    active: false,
    path: "/biaggregate",
    items: [
      {
        id: 1,
        title: "AI分析設定",
        url: "/biaggregate/aisummary/configuration/show",
        is_edit_page: false,
      },
      {
        id: 2,
        title: "主因仮説/打ち手コメントマスタ",
        url: "/biaggregate/causemeasure/list",
        is_edit_page: false,
      },
    ],
  },
];
